require('./bootstrap');

require('./script');